import CryptoJS from 'crypto-js';

/**
 * 비밀번호를 SHA-256으로 해시화
 * @param {string} password - 원본 비밀번호
 * @returns {string} 해시화된 비밀번호
 */
export const hashPassword = (password) => {
  return CryptoJS.SHA256(password).toString();
};

/**
 * 솔트와 함께 비밀번호 해시화 (더 강력한 보안)
 * @param {string} password - 원본 비밀번호
 * @param {string} salt - 솔트 (사용자명 등)
 * @returns {string} 해시화된 비밀번호
 */
export const hashPasswordWithSalt = (password, salt) => {
  return CryptoJS.SHA256(password + salt).toString();
};